import { useQuery } from "@tanstack/react-query";
import { User, getUsers } from "../clients/admin-client";

export const useUsers = () => {
    return useQuery<{ users: User[] }>(["users"], () => getUsers());
  };